import DeviceModule from "@/store/modules/device";
import POSConfigModule from "@/store/modules/pos-config";
import { defineComponent, reactive } from "vue";
import { EFR_SERVER_URL } from "@/utils/helpers/compliance";
export default defineComponent({
  name: "SystemInfo",
  components: {},
  setup: function setup() {
    var _DeviceModule$hardwar;

    var isSpainCertified = POSConfigModule.getGroupCountryCode === "ES" && ((_DeviceModule$hardwar = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar === void 0 ? void 0 : _DeviceModule$hardwar.deviceId);
    var ruleForm = reactive({
      appVersion: process.env.VUE_APP_VERSION
    });

    var openEFRDeclaration = function openEFRDeclaration() {
      window.open("".concat(EFR_SERVER_URL, "/declaration"), "_blank");
    };

    return {
      ruleForm: ruleForm,
      EFR_SERVER_URL: EFR_SERVER_URL,
      isSpainCertified: isSpainCertified,
      openEFRDeclaration: openEFRDeclaration
    };
  }
});